module.exports = __webpack_public_path__ + "static/img/7.e4e155d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/7.png
// module id = uooX
// module chunks = 4